import script from "./GiftArc.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftArc.vue?vue&type=script&setup=true&lang=js"

import "./GiftArc.vue?vue&type=style&index=0&id=43b15d3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b15d3d"]])

export default __exports__